export class SortDirection {
    public static Ascending : number = 0;
    public static Descending : number = 1;
}